export const money = value => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const getOpportunityValue = ticket => {
  const field = (ticket.contact?.extraInfo || []).find(item => item.name === 'valor');
  const value = Number(String(field?.value ?? '').replace(',', '.'));
  return Number.isFinite(value) && value >= 0 ? value : 0;
};

export const normalizeSearch = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-BR');

export const filterTickets = (tickets, filters) => {
  const query = normalizeSearch(filters.search).trim();
  return tickets.filter(ticket => {
    if (filters.userId && String(ticket.user?.id) !== filters.userId) return false;
    const created = new Date(ticket.createdAt);
    const date = Number.isNaN(created.getTime()) ? '' : `${created.getFullYear()}-${String(created.getMonth() + 1).padStart(2, '0')}-${String(created.getDate()).padStart(2, '0')}`;
    if (filters.start && (!date || date < filters.start)) return false;
    if (filters.end && (!date || date > filters.end)) return false;
    return !query || normalizeSearch([ticket.id, ticket.contact?.name, ticket.contact?.number, ticket.lastMessage, ...(ticket.tags || []).map(tag => tag.name)].join(' ')).includes(query);
  });
};

export const buildLanes = (tags, tickets, sortOrder, laneOrder = []) => {
  const sorted = [...tickets].sort((a, b) => sortOrder === 'valorDesc'
    ? getOpportunityValue(b) - getOpportunityValue(a) || a.id - b.id
    : sortOrder === 'lastMessageTime' ? new Date(b.updatedAt) - new Date(a.updatedAt) : a.id - b.id);
  const tagIds = new Set(tags.map(tag => String(tag.id)));
  const lanes = [{ id: 'lane0', title: 'Em aberto / Triagem', color: '#94a3b8', tickets: sorted.filter(ticket => !(ticket.tags || []).some(tag => tagIds.has(String(tag.id)))) },
    ...tags.map(tag => ({ id: String(tag.id), title: tag.name, color: tag.color || '#059669', tickets: sorted.filter(ticket => (ticket.tags || []).some(item => String(item.id) === String(tag.id))) }))];
  const order = new Map((laneOrder || []).map((id, index) => [String(id), index]));
  return lanes.sort((a, b) => (order.has(a.id) ? order.get(a.id) : Infinity) - (order.has(b.id) ? order.get(b.id) : Infinity));
};
